import { DEFAULT_SETTING, INITIAL_COLORS } from '../constants';
import { DEFAULT_SETTINGS_FONTS } from '@wix/podcasts-common/dist/settings';

function getDefaultSettings() {
  return {
    ...DEFAULT_SETTING,
    fonts: DEFAULT_SETTINGS_FONTS,
    colors: INITIAL_COLORS,
  };
}

export default getDefaultSettings;
